import React from "react";
import {
    Box,
    TextField,
    Grid
} from "@mui/material";
import { ViewContext } from "components/lib";
import { useContext } from "react";

export function BasicInfo({ formData, setFormData }) {
    const viewContext = useContext(ViewContext);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return (
        <Box sx={{ padding: "20px 10px", maxWidth: "800px", mx: "auto" }}>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextField
                        required
                        fullWidth
                        name="title"
                        label={viewContext.t('Components.ProjectCommon.basicInfo.title')}
                        placeholder={viewContext.t('Components.ProjectCommon.placeholder.title')}
                        value={formData.title}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        required
                        fullWidth
                        name="regNo"
                        label={viewContext.t('Components.ProjectCommon.basicInfo.regNo')}
                        placeholder={viewContext.t('Components.ProjectCommon.placeholder.regNo')}
                        value={formData.regNo}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        name="student"
                        label={viewContext.t('Components.ProjectCommon.basicInfo.student')}
                        placeholder={viewContext.t('Components.ProjectCommon.placeholder.student')}
                        value={formData.student}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        name="instructor"
                        label={viewContext.t('Components.ProjectCommon.basicInfo.instructor')}
                        placeholder={viewContext.t('Components.ProjectCommon.placeholder.instructor')}
                        value={formData.instructor}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        name="institution"
                        label={viewContext.t('Components.ProjectCommon.basicInfo.institution')}
                        placeholder={viewContext.t('Components.ProjectCommon.placeholder.institution')}
                        value={formData.institution}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        name="course"
                        label={viewContext.t('Components.ProjectCommon.basicInfo.course')}
                        placeholder={viewContext.t('Components.ProjectCommon.placeholder.course')}
                        value={formData.course}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        name="projectType"
                        label={viewContext.t('Components.ProjectCommon.basicInfo.type')}
                        placeholder={viewContext.t('Components.ProjectCommon.placeholder.type')}
                        value={formData.projectType}
                        onChange={(e) => {
                            setFormData({ ...formData, projectType: e.target.value });
                        }}
                        onBlur={(e) => {
                            let value = e.target.value;
                            value = value.replace(/[^a-zA-Z0-9, ]/g, "");
                            value = value.replace(/\s*,\s*/g, ", ");
                            value = value.trim().replace(/^,|,$/g, "");
                            setFormData({ ...formData, projectType: value });
                        }}
                        helperText={viewContext.t('Components.ProjectCommon.helper.type')}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        name="technologies"
                        label={viewContext.t('Components.ProjectCommon.basicInfo.technology')}
                        placeholder={viewContext.t('Components.ProjectCommon.placeholder.technology')}
                        value={formData.technologies}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        name="keywords"
                        label={viewContext.t('Components.ProjectCommon.basicInfo.keywords')}
                        placeholder={viewContext.t('Components.ProjectCommon.placeholder.keywords')}
                        value={formData.keywords}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        name="abstract"
                        label={viewContext.t('Components.ProjectCommon.basicInfo.abstract')}
                        placeholder={viewContext.t('Components.ProjectCommon.placeholder.abstract')}
                        value={formData.abstract}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        name="acknowledgements"
                        label={viewContext.t('Components.ProjectCommon.basicInfo.acknowledgement')}
                        placeholder={viewContext.t('Components.ProjectCommon.placeholder.acknowledgement')}
                        value={formData.acknowledgements}
                        onChange={handleChange}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}